import {
  mailRegex,
  capitalizeRegex,
  telRegex,
  noSpecialCharsRegex,
  onlyCapitalAndSpace,
  prenomRegex,
  mobileRegex,
  onlyStringNumber,
  cityRegex,
  zipCodeWithoutCorsicaDoms
} from '../../regex';
import validate from 'validate.js';
import moment from 'moment';

const requis = '^Ce champ est requis';
const maxMessage = 'Le champ ne doit pas contenir plus de ';
const isMessage = 'Le champ doit contenir exactement ';

const allowEmpty = (value, obj) => {
  if (value === '') return null;
  return obj;
};

validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse: function(value) {
    return +moment.utc(value);
  },
  // Input is a unix timestamp
  format: function(value, options) {
    const format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
    return moment.utc(value).format(format);
  }
});

export default {
  firstname: {
    presence: { allowEmpty: false, message: requis, label: 'Prénom' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: prenomRegex,
      message:
        '^Le prénom ne doit comporter que des lettres et commencer par une majuscule'
    }
  },
  lastname: {
    presence: { allowEmpty: false, message: requis, label: 'Nom' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: onlyCapitalAndSpace,
      message: '^Le nom ne doit comporter que des lettres'
    }
  },
  prenom: {
    presence: { allowEmpty: false, message: requis, label: 'Prénom' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: prenomRegex,
      message:
        '^Le prénom ne doit comporter que des lettres et commencer par une majuscule'
    }
  },
  nom: {
    presence: { allowEmpty: false, message: requis, label: 'Nom' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: onlyCapitalAndSpace,
      message: '^Le nom ne doit comporter que des lettres'
    }
  },
  email: {
    presence: { allowEmpty: false, message: requis, label: 'E-mail' },
    email: { message: '^Veuillez entrer un mail valide' },
    length: {
      maximum: 64,
      message: maxMessage + ' 64 caractères'
    },
    format: {
      pattern: mailRegex,
      message: '^Veuillez entrer un mail valide'
    }
  },
  mail: {
    presence: { allowEmpty: false, message: requis, label: 'E-mail' },
    email: { message: '^Veuillez entrer un mail valide' },
    length: {
      maximum: 64,
      message: maxMessage + ' 64 caractères'
    },
    format: {
      pattern: mailRegex,
      message: '^Veuillez entrer un mail valide'
    }
  },
  tel: {
    presence: { allowEmpty: false, message: requis, label: 'Téléphone' },
    format: {
      pattern: telRegex,
      flags: 'i',
      message:
        "^Le format du numéro n'est pas correct, il doit contenir 10 chiffres"
    }
  },
  mobilelivraison: {
    presence: { allowEmpty: false, message: requis, label: 'Mobile' },
    format: {
      pattern: mobileRegex,
      flags: 'i',
      message:
        '^Le numéro doit commencer par 06 ou 07 et doit contenir 10 chiffres'
    }
  },
  password: {
    presence: { allowEmpty: false, message: requis, label: 'Mot de passe' },
    length: {
      maximum: 128,
      message: maxMessage + 128 + ' caractères'
    }
  },
  confirm: value =>
    allowEmpty(value, {
      presence: {
        allowEmpty: false,
        message: requis,
        label: 'Confirmation de mot de passe'
      },
      equality: {
        attribute: 'password',
        message: '^Les mots de passe ne sont pas identiques.'
      }
    }),
  policy: {
    presence: { allowEmpty: false, message: requis, label: 'CGU' },
    inclusion: {
      within: [true],
      message: "^Vous devez accepter les conditions d'utilisation"
    }
  },
  civilite: {
    presence: { allowEmpty: false, message: requis, label: 'Civilite' },
    inclusion: {
      within: { madame: 'Madame', monsieur: 'Monsieur' },
      message: '^Veuillez sélectionner la civilité'
    }
  },
  methodepaiement: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Méthode de paiement'
    },
    inclusion: {
      within: {
        cb: 'Carte Bancaire',
        especes: 'Espèces',
        cheque: 'Chèques',
        mandat_administratif: 'Mandat_Administratif',
        virement: 'Virement'
      },
      message: '^Veuillez sélectionner la méthode de paiement'
    }
  },
  adressefacturation: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Adresse de Facturation'
    },
    format: {
      pattern: noSpecialCharsRegex,
      message: `^L'adresse de facturation ne doit pas comporter de caractères spéciaux`
    },
    length: {
      maximum: 128,
      message: maxMessage + 128 + ' caractères'
    }
  },
  address: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Adresse de facturation'
    },
    length: {
      maximum: 128,
      message: maxMessage + 128 + ' caractères'
    }
  },
  cpfacturation: {
    presence: { allowEmpty: false, message: requis, label: 'Code Postal' },
    length: {
      is: 5,
      message: `^${isMessage} 5 chiffres (code postal)`
    },
    numericality: {
      message: '^Le code postal ne doit contenir que des chiffres'
    },
    format: {
      pattern: zipCodeWithoutCorsicaDoms,
      message: '^Vous ne pouvez pas facturer en Corse / DROM-COM'
    }
  },
  villefacturation: {
    presence: { allowEmpty: false, message: requis, label: 'Ville' },
    format: {
      pattern: cityRegex,
      message: ' ne doit pas comporter de caractères spéciaux'
    },
    length: {
      maximum: 32,
      message: maxMessage + 32 + ' caractères'
    }
  },
  city: {
    presence: { allowEmpty: false, message: requis, label: 'Ville' },
    length: {
      maximum: 32,
      message: maxMessage + 32 + ' caractères'
    },
    format: {
      pattern: cityRegex,
      message: ` ne doit pas comporter de caractères spéciaux`
    }
  },
  civilitelivraison: {
    presence: { allowEmpty: true, message: requis, label: 'Civilite' },
    inclusion: {
      within: { madame: 'Madame', monsieur: 'Monsieur' },
      message: '^Veuillez sélectionner la civilité de livraison'
    }
  },
  adresselivraison: {
    presence: {
      allowEmpty: true,
      message: requis,
      label: 'Adresse de livraison'
    },
    format: {
      pattern: noSpecialCharsRegex,
      message: `^L'adresse de livraison ne doit pas comporter de caractères spéciaux`
    },
    length: {
      maximum: 128,
      message: maxMessage + 128 + ' caractères'
    }
  },
  cplivraison: {
    presence: { allowEmpty: true, message: requis, label: 'Code Postal' },
    length: {
      is: 5,
      message: `^${isMessage} 5 chiffres (code postal)`
    },
    numericality: {
      message: '^Le code postal ne doit contenir que des chiffres'
    },
    format: {
      pattern: zipCodeWithoutCorsicaDoms,
      message: '^Vous ne pouvez pas livrer en Corse / DROM-COM'
    }
  },
  zipCode: {
    presence: { allowEmpty: true, message: requis, label: 'Code Postal' },
    format: {
      pattern: onlyStringNumber,
      message: '^Seuls les chiffres sont acceptés dans le code postal'
    },
    length: {
      is: 5,
      message: `^${isMessage} 5 chiffres (code postal)`
    }
  },
  villelivraison: {
    presence: { allowEmpty: true, message: requis, label: 'Ville' },
    format: {
      pattern: cityRegex,
      message: ' ne doit pas comporter de caractères spéciaux'
    },
    length: {
      maximum: 32,
      message: maxMessage + 32 + ' caractères'
    }
  },
  prenomlivraison: {
    presence: { allowEmpty: false, message: requis, label: 'Prénom' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: capitalizeRegex,
      message:
        '^Le prénom de livraison ne doit comporter que des lettres et commencer par une majuscule'
    }
  },
  nomlivraison: {
    presence: { allowEmpty: false, message: requis, label: 'Nom' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: onlyCapitalAndSpace,
      message: 'Le nom de livraison ne doit comporter que des lettres'
    }
  },
  nomsociete: {
    presence: { allowEmpty: true, message: requis, label: 'Nom de société' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    }
  },
  lyceeName: {
    presence: { allowEmpty: false, message: requis, label: 'Nom du lycée' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: noSpecialCharsRegex,
      message: '^Le nom du lycée ne doit pas comporter de caractères spéciaux'
    }
  },
  academie: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Sélectionnez votre académie'
    }
  },
  classeName: {
    presence: { allowEmpty: false, message: requis, label: 'Nom de la classe' },
    length: {
      maximum: 32,
      message: maxMessage + ' 32 caractères'
    },
    format: {
      pattern: noSpecialCharsRegex,
      message:
        '^Le nom de la classe ne doit pas comporter de caractères spéciaux'
    }
  },
  filliere: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Sélectionnez votre filière'
    }
  },
  niveau: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Sélectionnez le niveau de votre classe'
    }
  },
  debut: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Date de début'
    },
    datetime: {
      dateOnly: false,
      message: '^La date doit être au format : jj mm aaaa'
    }
  },
  fin: {
    presence: {
      allowEmpty: false,
      message: requis,
      label: 'Date de fin'
    },
    datetime: {
      dateOnly: false,
      message: '^La date doit être au format : jj mm aaaa'
    }
  }
};
